import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(() => ({
    title: {
        fontWeight: 'bold',
        marginLeft: 8,
    },
}));
